import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth Store
export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      
      setAuth: (user, token) => {
        set({ user, token, isAuthenticated: !!token });
      },
      
      logout: () => {
        set({ user: null, token: null, isAuthenticated: false });
        useCartStore.getState().clearLocalCart();
      },
      
      getAuthHeader: () => {
        const token = get().token;
        return token ? { Authorization: `Bearer ${token}` } : {};
      },
    }),
    { name: 'auth-storage' }
  )
);

// Cart Store
export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      isLoading: false,
      
      fetchCart: async () => {
        const { isAuthenticated } = useAuthStore.getState();
        if (!isAuthenticated) return;
        
        set({ isLoading: true });
        try {
          const headers = useAuthStore.getState().getAuthHeader();
          const res = await axios.get(`${API}/cart`, { headers });
          set({ items: res.data, isLoading: false });
        } catch (error) {
          console.error('Error fetching cart:', error);
          set({ isLoading: false });
        }
      },
      
      addToCart: async (productId, quantity = 1) => {
        const { isAuthenticated } = useAuthStore.getState();
        if (!isAuthenticated) return false;
        
        try {
          const headers = useAuthStore.getState().getAuthHeader();
          await axios.post(`${API}/cart`, { product_id: productId, quantity }, { headers });
          await get().fetchCart();
          return true;
        } catch (error) {
          console.error('Error adding to cart:', error);
          return false;
        }
      },
      
      updateQuantity: async (itemId, quantity) => {
        const { isAuthenticated } = useAuthStore.getState();
        if (!isAuthenticated) return;
        
        try {
          const headers = useAuthStore.getState().getAuthHeader();
          await axios.put(`${API}/cart/${itemId}`, { product_id: '', quantity }, { headers });
          await get().fetchCart();
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      },
      
      removeItem: async (itemId) => {
        const { isAuthenticated } = useAuthStore.getState();
        if (!isAuthenticated) return;
        
        try {
          const headers = useAuthStore.getState().getAuthHeader();
          await axios.delete(`${API}/cart/${itemId}`, { headers });
          await get().fetchCart();
        } catch (error) {
          console.error('Error removing item:', error);
        }
      },
      
      clearLocalCart: () => set({ items: [] }),
      
      getTotal: () => {
        const items = get().items;
        return items.reduce((sum, item) => sum + (item.product_price * item.quantity), 0);
      },
      
      getItemCount: () => {
        const items = get().items;
        return items.reduce((sum, item) => sum + item.quantity, 0);
      },
    }),
    { name: 'cart-storage' }
  )
);
